import { httpDelete, httpGet, httpPatch, httpPost } from '../http.service'

const encoded = (id: string) => encodeURIComponent(id)

class RoleService {
	async fetchListing() {
		return await httpGet<any>('api/v1/admin/role')
	}
	async create(params: { name: string; id?: string }) {
		return await httpPost<any>('api/v1/admin/role', params)
	}
	async update(id: string, params: { name?: string }) {
		return await httpPatch<any>(`api/v1/admin/role/${encoded(id)}`, params)
	}
	async delete(id: string) {
		return await httpDelete<any>(`api/v1/admin/role/${encoded(id)}`)
	}
	async detail(id: string) {
		return await httpGet<any>(`api/v1/admin/role/${encoded(id)}`)
	}
}
const roleService = new RoleService()
export { roleService }
